import RouterSection from '@/layout/components/RouterSection'

export default {
  path: '/master',
  name: 'master_home',
  component: RouterSection,
  redirect: { name: 'SiteManage' },
  children: [
    {
      path: 'siteManage',
      name: 'SiteManage',
      // beforeEnter() {
      //   Message.info('<p>21년 7월, <span class="font-weight-bold">현대에너지솔루션 모니터링시스템</span>의</p><p>새로운 모습을 여러분의 사업에 펼쳐드리겠습니다.</p>')
      // }
      // props: true,
      component: () => import('@/views/master/SiteManage.vue')
    },
    {
      path: 'siteRegister',
      name: 'SiteRegister',
      props: true,
      component: () => import('@/views/master/SiteRegister.vue')
    },
    {
      path: 'siteEssReg',
      name: 'SiteEssReg',
      props: true,
      component: () => import('@/views/master/SiteDetailESS.vue')
    },
    {
      path: 'unitPriceManage',
      name: 'UnitPriceManage',
      props: true,
      component: () => import('@/views/master/UnitPriceManage.vue')
    },
    {
      path: 'migration',
      name: 'Migration',
      props: true,
      component: () => import('@/views/master/Migration.vue')
    },
    {
      path: 'siteBillManage',
      name: 'SiteBillManage',
      props: true,
      component: () => import('@/views/master/SiteBillManage.vue')
    }
  ]
}
